import { useEffect, useState } from "react";

import { profile } from "@/data/profile";

import { MatrixRain } from "@/components/MatrixRain";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { MarqueeSongs } from "@/components/MarqueeSongs";
import { GreenScreenMascot } from "@/components/GreenScreenMascot";
import { FlashMessage } from "@/components/FlashMessage";

import { useMusic } from "@/context/MusicContext";


export default function SongCatalogue() {

const [songs, setSongs] = useState([]);
const { playSong } = useMusic();


useEffect(() => {
  async function loadSongs() {
    try {
      console.log("Loading song catalogue from local library...");

      const response = await fetch("/data/song_library.json");

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const library = await response.json();

      const librarySongs = [...(library.songs || [])].sort(
        (a, b) => a.id - b.id
      );

      console.log(
        `Loaded ${librarySongs.length} songs into catalogue.`
      );

      setSongs(librarySongs);
    } catch (error) {
      console.error(
        "Failed loading song library:",
        error
      );
    }
  }

  loadSongs();
}, []);


  return (

    <div
      id="top"
      data-testid="song-catalogue-page"
      className="relative min-h-screen bg-black grain scanlines"
    >

      <MatrixRain />

      <GreenScreenMascot />


      {/* Radial vignette */}
      <div
        className="pointer-events-none fixed inset-0 z-[1]"
        style={{
          background:
            "radial-gradient(120% 90% at 50% 0%, rgba(0,0,0,0.2), rgba(0,0,0,0.85) 75%)",
        }}
        aria-hidden
      />


      <Nav />


      <main className="relative z-10">

        <Hero
          profile={profile}
          showAvatar={false}
          cataloguePage={true}
        />

        <MarqueeSongs />


        <section
          className="
          mx-auto
          max-w-6xl
          px-6
          py-12
          "
        >

          <div
            className="
            mt-12
            grid
            gap-6
            md:grid-cols-2
            lg:grid-cols-3
            "
          >

            {songs.map((song) => (

              <div
                key={song.id}
                className="
                rounded-xl
                border
                border-matrix-green/30
                bg-black/50
                p-6
                "
              >

                <h2
                  className="
                  font-display
                  text-xl
                  uppercase
                  text-white
                  "
                >
                  {song.title}
                </h2>


                <p className="mt-2 font-mono text-sm text-white/60">
                  {song.genre}
                </p>


                <p className="mt-4 font-mono text-sm text-white/50">
                  {song.description}
                </p>


                <button
                  onClick={() =>
                    playSong({
                      ...song,
                      url: song.url || song.file,
                    })
                  }
                  className="
                    mt-5
                    rounded-full
                    border
                    border-matrix-green/40
                    px-6
                    py-2
                    font-display
                    text-sm
                    uppercase
                    text-matrix-green
                    transition-all
                    hover:bg-matrix-green/10
                  "
                >
                  ▶ Play
                </button>


              </div>

            ))}


          </div>


        </section>


      </main>

      <FlashMessage />

    </div>

  );
}